import { fetchAuthSession } from 'aws-amplify/auth';

/** The Cognito session is gone, so there is no token to send. */
export class SessionEndedError extends Error {
  constructor() {
    super('Signed out: no Cognito token to send');
    this.name = 'SessionEndedError';
  }
}

/** The signed-in user's current Cognito token; Amplify refreshes it when it is about to expire. */
export const cognitoToken = async (kind: 'accessToken' | 'idToken'): Promise<string> => {
  const { tokens } = await fetchAuthSession();
  const token = tokens?.[kind];
  if (!token) {
    throw new SessionEndedError();
  }
  return token.toString();
};
